import { useMemo } from 'react';
import { defaultSectionRegistry } from 'ai-rendering-library/sections/formatters/registry';
import { buildTextBlockMessagePayload } from 'ai-rendering-library/sections/breezeEngine/buildMessagePayload';
import { ActionsResponseSectionTypename, CatalogItemRecommendationSectionTypename, InlineAcademyVideoResponseSectionTypename } from '../../types';
import { AcademyClipCard } from '../DynamicSections/AcademyClipCard';
import { RecommendationCard } from '../DynamicSections/AcademyRecommendations';
import { AcademySuggestionButtons } from '../DynamicSections/AcademySuggestionButtons';
import AISectionV2 from 'ai-rendering-library/sections/AISectionV2';
import { jsx as _jsx } from "react/jsx-runtime";
const academyRegistry = Object.assign({}, defaultSectionRegistry, {
  [CatalogItemRecommendationSectionTypename]: ({
    section
  }) => /*#__PURE__*/_jsx(RecommendationCard, {
    section: section
  }),
  [InlineAcademyVideoResponseSectionTypename]: ({
    section
  }) => /*#__PURE__*/_jsx(AcademyClipCard, {
    section: section
  }),
  [ActionsResponseSectionTypename]: ({
    section
  }) => /*#__PURE__*/_jsx(AcademySuggestionButtons, {
    section: section
  })
});
const AcademyTextBlock = ({
  block,
  message
}) => {
  var _message$id, _messagePayload$secti;
  const textBlock = block;
  const sectionId = (_message$id = message === null || message === void 0 ? void 0 : message.id) !== null && _message$id !== void 0 ? _message$id : '';
  const messagePayload = useMemo(() => buildTextBlockMessagePayload(textBlock, sectionId, message), [textBlock, sectionId, message]);
  const sections = (_messagePayload$secti = messagePayload.sections) !== null && _messagePayload$secti !== void 0 ? _messagePayload$secti : [];
  return sections.map((section, i) => /*#__PURE__*/_jsx(AISectionV2, {
    message: messagePayload,
    section: section,
    registry: academyRegistry
  }, i));
};
export const ACADEMY_BLOCK_RENDERERS = {
  TEXT: AcademyTextBlock
};